import React from 'react';
import './Resources.css';

function Resources() {
  const resources = [
    {
      title: 'Practice Chanters',
      links: [
        {
          name: 'GlenCoe Electronic Practice Chanter',
          url: 'https://glencoebagpipes.com/?ref=bagpipeblasphemy',
          description: 'Electronic practice chanter with headphone capability for silent practice',
        },
        {
          name: 'Barefoot Bagpiper Chanter Set',
          url: 'https://a.co/d/escTPif',
          description: 'Complete practice chanter set for beginners',
        },
      ],
    },
    {
      title: 'Electronic Bagpipes',
      links: [
        {
          name: 'RedPipes Electronic Bagpipes',
          url: 'https://www.redpipes.eu/shop/en/',
          description: 'High-quality electronic bagpipes for practice and performance',
        },
      ],
    },
    {
      title: 'Gear',
      links: [
        {
          name: "The Piper's Hut",
          url: 'https://www.thepipershut.com/',
          description: 'Complete selection of bagpipes, accessories, and Highland wear',
        },
      ],
    },
    {
      title: 'YouTube Instruction',
      links: [
        {
          name: 'Matt Willis Bagpiper',
          url: 'https://www.youtube.com/@mattwillisbagpiper',
          description: 'Free bagpipe tutorials and instruction from an experienced piper',
        },
      ],
    },
    {
      title: 'Online Learning',
      links: [
        {
          name: 'National Piping Centre',
          url: 'https://www.thepipingcentre.co.uk/learn/online-learning',
          description: 'Professional online piping instruction',
        },
        {
          name: 'Dojo University',
          url: 'https://dojouniversity.com/',
          description: 'Online bagpipe lessons and community',
        },
      ],
    },
  ];

  return (
    <div className="full-page-wrapper" style={{ background: 'linear-gradient(to left bottom, #777777, #1a1a1a)', height: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center', width: '100%', paddingTop: '60px' }}>
      <div className="app-theme-resources" style={{ paddingTop: 'var(--spacing-lg, 30px)', width: '100%', maxWidth: '800px', overflowY: 'auto', height: 'calc(100vh - 60px)' }}>
        <div className="resources">
          {resources.map((category, index) => (
            <div key={index} className="resource-category">
              <h3>{category.title}</h3>
              <ul>
                {category.links.map((link, linkIndex) => (
                  <li key={linkIndex}>
                    <a href={link.url} target="_blank" rel="noopener noreferrer">
                      {link.name}
                    </a>
                    <p>{link.description}</p>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Resources;
